/** @jsx jsx */
import { jsx } from '@emotion/react';
import { ReactNode } from 'react';
import { labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * Children to render within the loader, typically
   * `SkeletonBlock` and `SkeletonText` components that
   * are wrapped in a layout component.
   */
  children: ReactNode;
};

const Styles = labelStyles('SkeletonLoader', {
  root: {
    display: 'block',
    overflow: 'hidden',
  },
});

/**
 * Renders a wrapper to be used around `SkeletonBlock` and `SkeletonText` components.
 */
export const SkeletonLoader = (props: Props) => {
  return (
    <div css={Styles.root} data-zds>
      {props.children}
    </div>
  );
};
